import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcSaveDoc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M23 18a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm0 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z" />
      <path d="m25.303 22.293 1.437 1.39-4.728 4.888-2.736-2.736 1.414-1.414 1.298 1.298zM3 0h16.005L25 5.564V19.04h-2V6.436L18.221 2H5v24h12v2H3z" />
      <path d="M19.043 1v5.007H24v2h-6.957V1z" />
    </g>
  </svg>
);
export default SvgIcSaveDoc;
